export default __webpack_public_path__ + "static/18_33-2861ad78d016f210568f94d0d5ae0922.png";